import { QueryClient } from "@tanstack/react-query";

/**
 * QueryClient global — unified across desktop, mobile web, Android, iOS
 * and tablet so every device shares the same caching policy. Realtime
 * subscriptions (see `lib/realtimeSync.ts` + `hooks/useUnifiedSync.ts`)
 * keep this cache in sync; these defaults guarantee that any missed
 * event is recovered on focus, reconnect, mount, or window blur/focus.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      gcTime: 1000 * 60 * 15,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: "always",
      retry: 1,
      retryDelay: (attemptIndex: number) =>
        Math.min(1000 * 2 ** attemptIndex, 10000),
      refetchIntervalInBackground: false,
      networkMode: "always",
    },
    mutations: {
      retry: 0,
      networkMode: "always",
    },
  },
});
